import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import API_CONFIG from './config/api';
import CreationWizard, { ReviewCard } from './CreationWizard';

function NovaSimulacao({ show, onClose, onSimulacaoCriada, ficha }) {
  const API_URL = `${API_CONFIG.API_URL}`;

  const [formData, setFormData] = useState({
    ficha_id: '',
    // Dados do cliente
    nome: '',
    cpf: '',
    nascimento: '',
    cnh: '',
    celular: '',
    
    // Dados do veículo
    veiculo_id: '',
    veiculo: '',
    veiculoBusca: '', // Campo de busca
    placa: '',
    ano: '',
    combustivel: '',
    
    // Dados financeiros
    valorVenda: '',
    entrada: '',
    financiado: '',
    
    // Extras
    clienteNaLoja: false,
    observacoes: ''
  });

  const consultaPlacaRef = useRef(0);
  const [consultandoPlaca, setConsultandoPlaca] = useState(false);
  const [mensagemPlaca, setMensagemPlaca] = useState('');
  const [fotoFalhou, setFotoFalhou] = useState('');
  useEffect(() => () => { consultaPlacaRef.current += 1; }, []);
  const [veiculos, setVeiculos] = useState([]);
  const [veiculosFiltrados, setVeiculosFiltrados] = useState([]);
  const [mostrarOpcoes, setMostrarOpcoes] = useState(false);
  const [isManualEntry, setIsManualEntry] = useState(false);
  const [step, setStep] = useState(0);
  const camposEtapa = [['nome', 'cpf', 'nascimento', 'celular'], ['veiculo_id', 'veiculo', 'ano', 'placa'], ['valorVenda']];
  const [carregando, setCarregando] = useState(false);
  const [erros, setErros] = useState({});
  const autocompleteRef = useRef(null);
  
  // Refs para os campos do formulário
  const campoRefs = {
    nome: useRef(null),
    cpf: useRef(null),
    nascimento: useRef(null),
    celular: useRef(null),
    cnh: useRef(null),
    veiculo_id: useRef(null),
    veiculo: useRef(null),
    valorVenda: useRef(null)
  };

  useEffect(() => {
    if (show) {
      consultaPlacaRef.current += 1;
      setConsultandoPlaca(false);
      setMensagemPlaca('');
      setFotoFalhou('');
      setStep(0);
      carregarVeiculos();
      
      // Se tem ficha, preencher TODOS os dados disponíveis da ficha
      if (ficha) {
        setFormData({
          ficha_id: ficha._id,
          // Dados do cliente (da ficha)
          nome: ficha.cliente?.nome || '',
          cpf: ficha.cliente?.cpf || '', // Somente leitura
          nascimento: ficha.cliente?.data_nascimento 
            ? new Date(ficha.cliente.data_nascimento).toISOString().split('T')[0] 
            : '',
          cnh: ficha.cliente?.cnh || '',
          celular: ficha.cliente?.celular || ficha.cliente?.telefone || '',
          // Dados do veículo (vazios para seleção)
          veiculo_id: '',
          veiculo: '',
          veiculoBusca: '',
          placa: '',
          ano: '',
          combustivel: '',
          // Dados financeiros (vazios)
          valorVenda: '',
          entrada: '',
          financiado: '',
          clienteNaLoja: false,
          observacoes: ''
        });
        // Se já tem dados, pode vir colapsado

      } else {
        // Limpar formulário ao abrir sem ficha
        setFormData({
          ficha_id: '',
          nome: '',
          cpf: '',
          nascimento: '',
          cnh: '',
          celular: '',
          veiculo_id: '',
          veiculo: '',
          veiculoBusca: '',
          placa: '',
          ano: '',
          combustivel: '',
          valorVenda: '',
          entrada: '',
          financiado: '',
          clienteNaLoja: false,
          observacoes: ''
        });
      }
      setIsManualEntry(false);
      setErros({});
    }
  }, [show, ficha]);

  // Fechar autocomplete ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (autocompleteRef.current && !autocompleteRef.current.contains(event.target)) {
        setMostrarOpcoes(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Filtrar veículos conforme digita
  useEffect(() => {
    if (formData.veiculoBusca && veiculos.length > 0) {
      const search = formData.veiculoBusca.toLowerCase().trim();
      const termosBusca = search.split(/\s+/).filter(t => t.length > 0);

      const filtrados = veiculos.filter(v => {
        // Combinar todos os campos de busca em um único texto
        const textoCompleto = [
          v.marca || '',
          v.modelo || '',
          v.ano_modelo || '',
          v.ano_fabricacao || '',
          v.placa || '',
          v.cor || ''
        ].join(' ').toLowerCase();

        // Verificar se TODOS os termos de busca estão presentes no texto completo
        return termosBusca.every(termo =>
          textoCompleto.includes(termo)
        );
      });
      setVeiculosFiltrados(filtrados);
    } else {
      setVeiculosFiltrados(veiculos);
    }
  }, [formData.veiculoBusca, veiculos]);

  const carregarVeiculos = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/veiculos`, {
        headers: { 'x-auth-token': token }
      });
      
      if (response.data.success) {
        // Carregar todos os veículos, independente do status
        setVeiculos(response.data.data);
      }
    } catch (error) {
    }
  };

  const formatarMoeda = (valor) => {
    const numero = valor.replace(/\D/g, '');
    if (!numero) return '';
    const valorNumerico = parseFloat(numero) / 100;
    return valorNumerico.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const desformatarMoeda = (valor) => {
    if (!valor) return '';
    return valor.replace(/[R$\s.]/g, '').replace(',', '.');
  };

  const formatarCPF = (valor) => {
    const numeros = valor.replace(/\D/g, '');
    if (numeros.length <= 11) {
      return numeros
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    }
    return valor;
  };

  const formatarCelular = (valor) => {
    const numeros = valor.replace(/\D/g, '');
    if (numeros.length <= 11) {
      return numeros
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{5})(\d)/, '$1-$2');
    }
    return valor;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === 'checkbox') {
      setFormData(prev => ({ ...prev, [name]: checked }));
      return;
    }

    let valorFormatado = value;
    if (name === 'placa') {
      valorFormatado = value.toUpperCase();
      setMensagemPlaca('');
    }

    // Formatar campos específicos
    if (name === 'cpf') {
      valorFormatado = formatarCPF(value);
    } else if (name === 'celular') {
      valorFormatado = formatarCelular(value);
    } else if (['valorVenda', 'entrada'].includes(name)) {
      valorFormatado = formatarMoeda(value);
    }

    setFormData(prev => {
      const novoForm = { ...prev, [name]: valorFormatado };
      
      // Calcular valor financiado automaticamente
      if (name === 'valorVenda' || name === 'entrada') {
        const venda = parseFloat(desformatarMoeda(name === 'valorVenda' ? valorFormatado : novoForm.valorVenda)) || 0;
        const entrada = parseFloat(desformatarMoeda(name === 'entrada' ? valorFormatado : novoForm.entrada)) || 0;
        const financiado = venda - entrada;
        novoForm.financiado = financiado > 0 ? formatarMoeda(String(Math.round(financiado * 100))) : '';
      }

      return novoForm;
    });

    // Limpar erro do campo
    if (erros[name]) {
      setErros(prev => ({ ...prev, [name]: '' }));
    }
  };

  const consultarPlaca = async () => {
    if (consultandoPlaca) return;
    const placa = formData.placa.toUpperCase().replace(/[\s-]/g, '');
    if (!/^[A-Z]{3}\d[A-Z\d]\d{2}$/.test(placa)) {
      setMensagemPlaca('Informe uma placa válida, como ABC1234 ou ABC1D23.');
      return;
    }
    const consulta = ++consultaPlacaRef.current;
    setConsultandoPlaca(true);
    setMensagemPlaca('Consultando placa…');
    try {
      const response = await axios.post(`${API_URL}/negociacoes/consultar-placa`, { placa }, {
        headers: { 'x-auth-token': localStorage.getItem('token') }, timeout: 65000
      });
      if (consulta !== consultaPlacaRef.current) return;
      if (!response.data.success) throw new Error(response.data.message || 'Não foi possível consultar a placa.');
      const dados = response.data.data || {};
      const modelo = dados.modelo || '';
      const veiculo = dados.marca && !modelo.toUpperCase().startsWith(dados.marca.toUpperCase()) ? [dados.marca, modelo].filter(Boolean).join(' ') : modelo;
      setFormData(prev => ({ ...prev, placa,
        veiculo: veiculo || prev.veiculo,
        ano: [dados.anoFabricacao, dados.anoModelo].filter(Boolean).join('/') || prev.ano,
        combustivel: dados.combustivel || prev.combustivel
      }));
      setErros({});
      setMensagemPlaca('Dados encontrados. Confira e complete os campos restantes.');
    } catch (error) {
      if (consulta === consultaPlacaRef.current) setMensagemPlaca(error.response?.data?.message || 'Não foi possível consultar a placa. Tente novamente ou preencha manualmente.');
    } finally {
      if (consulta === consultaPlacaRef.current) setConsultandoPlaca(false);
    }
  };

  const handleVeiculoBuscaChange = (e) => {
    setFormData(prev => ({ ...prev, veiculoBusca: e.target.value }));
    setMostrarOpcoes(true);
  };

  const handleSelecionarVeiculo = (veiculo) => {
    const valorVenda = veiculo.preco_venda ? 
      formatarMoeda(String(parseFloat(veiculo.preco_venda) * 100)) : '';
    
    // Formatar como Fabricação/Modelo (ex: 2022/2023)
    let anoExibicao = '';
    if (veiculo.ano_fabricacao && veiculo.ano_modelo) {
      anoExibicao = `${veiculo.ano_fabricacao}/${veiculo.ano_modelo}`;
    } else {
      anoExibicao = veiculo.ano_modelo || veiculo.ano_fabricacao || '';
    }
    
    setFormData(prev => ({
      ...prev,
      veiculo_id: veiculo._id,
      veiculo: `${veiculo.marca} ${veiculo.modelo}`,
      veiculoBusca: `${veiculo.marca} ${veiculo.modelo} - ${anoExibicao} - ${veiculo.placa ? veiculo.placa.replace(/-/g, '') : ''}`,
      placa: veiculo.placa || '',
      ano: anoExibicao,
      combustivel: veiculo.combustivel || '',
      valorVenda: valorVenda,
      // Recalcular financiado se já tiver entrada
      financiado: formatarMoeda(String(Math.round(Math.max(0, (parseFloat(desformatarMoeda(valorVenda)) || 0) - (parseFloat(desformatarMoeda(prev.entrada)) || 0)) * 100)))
    }));

    setMostrarOpcoes(false);
    
    // Limpar erro se houver
    if (erros.veiculo_id) {
      setErros(prev => ({ ...prev, veiculo_id: '' }));
    }
  };

  const validarFormulario = (etapa = null) => {
    const novosErros = {};

    // Campos obrigatórios
    if (!formData.nome.trim()) novosErros.nome = 'Nome completo é obrigatório';
    if (!formData.cpf.trim()) novosErros.cpf = 'CPF é obrigatório';
    if (!formData.nascimento) novosErros.nascimento = 'Data de nascimento é obrigatória';
    if (!formData.celular.trim()) novosErros.celular = 'Celular é obrigatório';
    // CNH agora é opcional
    
    if (isManualEntry) {
      if (!formData.veiculo.trim()) novosErros.veiculo = 'Marca/Modelo do veículo é obrigatório';
      if (!formData.ano.trim()) novosErros.ano = 'Ano Fabricação/Modelo é obrigatório';
      if (!formData.placa.trim()) novosErros.placa = 'Placa é obrigatória';
    } else {
      if (!formData.veiculo_id) novosErros.veiculo_id = 'Selecione um veículo';
    }
    
    if (!formData.valorVenda) novosErros.valorVenda = 'Valor de venda é obrigatório';

    if (etapa !== null) Object.keys(novosErros).forEach(key => { if (!camposEtapa[etapa].includes(key)) delete novosErros[key]; });
    if (etapa === null && Object.keys(novosErros).length) setStep(camposEtapa.findIndex(campos => campos.includes(Object.keys(novosErros)[0])));

    // Se houver erros, registra também mensagem geral para aparecer em destaque
    if (Object.keys(novosErros).length > 0) {
      novosErros.geral = Object.values(novosErros)[0];
    }

    setErros(novosErros);
    
    // Se houver erros, fazer scroll para o primeiro campo com erro
    if (Object.keys(novosErros).length > 0) {
      const primeiroErro = Object.keys(novosErros)[0];
      const campoRef = campoRefs[primeiroErro];
      
      if (campoRef && campoRef.current) {
        campoRef.current.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center' 
        });
        campoRef.current.focus();
      }
    }
    
    return Object.keys(novosErros).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Evitar double-submit
    if (carregando || consultandoPlaca) return;
    
    if (step < 3) {
      if (validarFormulario(step)) setStep(step + 1);
      return;
    }
    if (!validarFormulario()) {
      return;
    }

    setCarregando(true);

    try {
      const token = localStorage.getItem('token');
      
      // Preparar dados para envio
      const dadosParaEnviar = {
        ficha_id: formData.ficha_id,
        nome: formData.nome,
        cpf: formData.cpf.replace(/\D/g, ''),
        nascimento: formData.nascimento,
        cnh: formData.cnh,
        celular: formData.celular.replace(/\D/g, ''),
        veiculo_id: isManualEntry ? undefined : formData.veiculo_id,
        veiculo: formData.veiculo,
        placa: formData.placa,
        ano: formData.ano,
        combustivel: formData.combustivel,
        valorVenda: desformatarMoeda(formData.valorVenda),
        entrada: desformatarMoeda(formData.entrada),
        financiado: desformatarMoeda(formData.financiado),
        clienteNaLoja: formData.clienteNaLoja,
        observacoes: formData.observacoes
      };

      const response = await axios.post(
        `${API_URL}/simulacoes`,
        dadosParaEnviar,
        {
          headers: { 'x-auth-token': token }
        }
      );

      if (response.data.success) {
        setErros({});
        if (onSimulacaoCriada) {
          onSimulacaoCriada();
        }
        onClose();
      } else {
        setErros({ geral: response.data.erro || response.data.message || 'Não foi possível criar a simulação. Tente novamente.' });
      }
    } catch (error) {
      setErros({ geral: error.response?.data?.erro || 'Erro ao criar simulação' });
    } finally {
      setCarregando(false);
    }
  };

  const veiculoSelecionado = !isManualEntry ? veiculos.find(v => v._id === formData.veiculo_id) : null;
  const fotoVeiculo = [...(veiculoSelecionado?.fotos || [])].sort((a, b) => (a.ordem || 0) - (b.ordem || 0)).find(f => /^https?:\/\//i.test(f.url || ''))?.url;

  if (!show) return null;

  return (
    <CreationWizard title="Nova simulação" steps={['Cliente', 'Veículo', 'Valores', 'Revisão']} step={step} onStep={setStep} onClose={onClose} onSubmit={handleSubmit} busy={carregando || consultandoPlaca} submitLabel="Criar simulação" error={erros.geral} description={['Confira os dados de quem vai financiar.', 'Escolha um veículo do estoque ou informe os dados manualmente.', 'Defina a entrada e confira o valor a financiar.', 'Confira o cliente, o veículo e os valores antes de concluir.'][step]}>
      {step === 0 && <>
        {ficha && <div className="cw-note">Dados preenchidos a partir da ficha do cliente.</div>}
              <div className="form-row">
                <div className="form-group full-width">
                  <label>Nome Completo *</label>
                  <input
                    ref={campoRefs.nome}
                    type="text"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    className={erros.nome ? 'error' : ''}
                    placeholder="Nome do cliente"
                  />
                  {erros.nome && <span className="error-message">{erros.nome}</span>}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>CPF *</label>
                  <input
                    ref={campoRefs.cpf}
                    type="text"
                    name="cpf"
                    readOnly={Boolean(ficha?.cliente?.cpf)}
                    value={formData.cpf}
                    onChange={handleChange}
                    className={erros.cpf ? 'error' : ''}
                    placeholder="000.000.000-00"
                    maxLength="14"
                  />
                  {erros.cpf && <span className="error-message">{erros.cpf}</span>}
                </div>

                <div className="form-group">
                  <label>Data de Nascimento *</label>
                  <input
                    ref={campoRefs.nascimento}
                    type="date"
                    name="nascimento"
                    value={formData.nascimento}
                    onChange={handleChange}
                    className={erros.nascimento ? 'error' : ''}
                  />
                  {erros.nascimento && <span className="error-message">{erros.nascimento}</span>}
                </div>

                <div className="form-group">
                  <label>Celular *</label>
                  <input
                    ref={campoRefs.celular}
                    type="text"
                    name="celular"
                    value={formData.celular}
                    onChange={handleChange}
                    className={erros.celular ? 'error' : ''}
                    placeholder="(00) 00000-0000"
                    maxLength="15"
                  />
                  {erros.celular && <span className="error-message">{erros.celular}</span>}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group full-width">
                  <label>Categoria CNH</label>
                  <select
                    ref={campoRefs.cnh}
                    name="cnh"
                    value={formData.cnh}
                    onChange={handleChange}
                    className={erros.cnh ? 'error' : ''}
                  >
                    <option value="">Selecione...</option>
                    {formData.cnh && !['A', 'B', 'AB', 'C', 'D', 'E', 'N'].includes(formData.cnh) && <option value={formData.cnh}>{formData.cnh}</option>}
                    <option value="A">A - Moto</option>
                    <option value="B">B - Carro</option>
                    <option value="AB">AB - Carro e Moto</option>
                    <option value="C">C - Caminhão</option>
                    <option value="D">D - Ônibus</option>
                    <option value="E">E - Carreta</option>
                    <option value="N">Não possui</option>
                  </select>
                  {erros.cnh && <span className="error-message">{erros.cnh}</span>}
                </div>
              </div>
      </>}
      {step === 1 && <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
<strong>Dados do veículo</strong>
              <button 
                type="button" 
                onClick={() => {
                  consultaPlacaRef.current += 1;
                  setMensagemPlaca('');
                  setIsManualEntry(!isManualEntry);
                  setFormData(prev => ({
                    ...prev,
                    veiculo_id: '',
                    veiculo: '',
                    veiculoBusca: '',
                    placa: '',
                    ano: '',
                    combustivel: '',
                    valorVenda: '',
                    financiado: ''
                  }));
                  setErros({});
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#3498db',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  fontSize: '0.9rem'
                }}
              >
                {isManualEntry ? '🔍 Buscar no estoque' : '✏️ Digitar dados manualmente'}
              </button>
            </div>
            
            {!isManualEntry ? (
              <div className="form-group full-width">
                <label>Buscar Veículo do Estoque *</label>
                <div className="autocomplete-wrapper" ref={autocompleteRef}>
                  <input
                    ref={campoRefs.veiculo_id}
                    type="text"
                    name="veiculoBusca"
                    value={formData.veiculoBusca}
                    onChange={handleVeiculoBuscaChange}
                    onFocus={() => setMostrarOpcoes(true)}
                    className={erros.veiculo_id ? 'error' : ''}
                    placeholder="Digite marca, modelo, placa ou ano..."
                    autoComplete="off"
                  />
                  {mostrarOpcoes && veiculosFiltrados.length > 0 && (
                    <ul className="autocomplete-options">
                      {veiculosFiltrados.slice(0, 10).map((veiculo) => (
                        <li
                          key={veiculo._id}
                          onClick={() => handleSelecionarVeiculo(veiculo)}
                          role="button"
                          tabIndex={0}
                          onKeyDown={event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); handleSelecionarVeiculo(veiculo); } }}
                          className="autocomplete-option"
                          style={{ padding: '10px', cursor: 'pointer' }}
                        >
                          <div style={{ fontWeight: '600', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                            <span>{veiculo.marca} {veiculo.modelo} - {veiculo.ano_fabricacao && veiculo.ano_modelo ? `${veiculo.ano_fabricacao}/${veiculo.ano_modelo}` : (veiculo.ano_modelo || veiculo.ano_fabricacao)}</span>
                            {veiculo.tipo && veiculo.tipo.includes('Repasse') && (
                              <span style={{
                                background: '#ff9800',
                                color: 'white',
                                padding: '2px 8px',
                                borderRadius: '12px',
                                fontSize: '0.75rem',
                                fontWeight: '600'
                              }}>
                                {veiculo.tipo}
                              </span>
                            )}
                            <span style={{
                              background: veiculo.status === 'Disponível' ? '#4caf50' : veiculo.status === 'Em negociação' ? '#ff9800' : '#999',
                              color: 'white',
                              padding: '2px 8px',
                              borderRadius: '12px',
                              fontSize: '0.75rem',
                              fontWeight: '600'
                            }}>
                              {veiculo.status}
                            </span>
                          </div>
                          <div style={{ fontSize: '0.85rem', color: '#666', marginTop: '4px' }}>
                            Placa: {veiculo.placa} | Combustível: {veiculo.combustivel}
                            {veiculo.preco_venda && ` | R$ ${parseFloat(veiculo.preco_venda).toLocaleString('pt-BR', {minimumFractionDigits: 2})}`}
                          </div>
                        </li>
                      ))}
                      {veiculosFiltrados.length > 10 && (
                        <li className="autocomplete-info" style={{ padding: '8px', color: '#666', fontSize: '0.85rem' }}>
                          +{veiculosFiltrados.length - 10} mais resultados...
                        </li>
                      )}
                    </ul>
                  )}
                  {mostrarOpcoes && formData.veiculoBusca && veiculosFiltrados.length === 0 && (
                    <ul className="autocomplete-options">
                      <li className="autocomplete-info" style={{ padding: '10px', color: '#999' }}>
                        Nenhum veículo encontrado
                      </li>
                    </ul>
                  )}
                </div>
                {erros.veiculo_id && <span className="error-message">{erros.veiculo_id}</span>}
              </div>
            ) : (<>
              <div className="form-group">
                <label htmlFor="sim-placa">Placa *</label>
                <div className="cw-cpf-search">
                  <input id="sim-placa" name="placa" value={formData.placa} onChange={handleChange} placeholder="ABC1D23" maxLength={8} className={erros.placa ? 'error' : ''} />
                  <button type="button" className="cw-secondary" onClick={consultarPlaca}>{consultandoPlaca ? 'Consultando…' : 'Consultar placa'}</button>
                </div>
                {mensagemPlaca && <p className="cw-note" role="status">{mensagemPlaca}</p>}
                {erros.placa && <span className="error-message">{erros.placa}</span>}
              </div>
              <div className="form-group full-width">
                <label>Veículo (Marca / Modelo) *</label>
                <input
                  ref={campoRefs.veiculo}
                  type="text"
                  name="veiculo"
                  value={formData.veiculo}
                  onChange={handleChange}
                  className={erros.veiculo ? 'error' : ''}
                  placeholder="Ex: VOLKSWAGEN GOL 1.0"
                />
                {erros.veiculo && <span className="error-message">{erros.veiculo}</span>}
              </div>
            </>)}

            {(formData.veiculo_id || isManualEntry) && (
              <div className="form-row">
                {!isManualEntry && <div className="form-group">
                  <label>Placa {isManualEntry && '*'}</label>
                  <input
                    type="text"
                    name="placa"
                    value={formData.placa}
                    onChange={handleChange}
                    className={erros.placa ? 'error' : ''}
                    placeholder="ABC-1234"
                    disabled={!isManualEntry}
                    style={!isManualEntry ? { background: '#f5f5f5', cursor: 'not-allowed' } : {}}
                  />
                  {erros.placa && <span className="error-message">{erros.placa}</span>}
                </div>}

                <div className="form-group">
                  <label>Ano {isManualEntry && '*'}</label>
                  <input
                    type="text"
                    name="ano"
                    value={formData.ano}
                    onChange={handleChange}
                    className={erros.ano ? 'error' : ''}
                    placeholder="2020 / 2021"
                    disabled={!isManualEntry}
                    style={!isManualEntry ? { background: '#f5f5f5', cursor: 'not-allowed' } : {}}
                  />
                  {erros.ano && <span className="error-message">{erros.ano}</span>}
                </div>

                <div className="form-group">
                  <label>Combustível</label>
                  <input
                    type="text"
                    name="combustivel"
                    value={formData.combustivel}
                    onChange={handleChange}
                    placeholder="Flex, Diesel, etc"
                    disabled={!isManualEntry}
                    style={!isManualEntry ? { background: '#f5f5f5', cursor: 'not-allowed' } : {}}
                  />
                </div>
              </div>
            )}
          </div>}

          {step === 2 && <>
          {fotoVeiculo && fotoFalhou !== fotoVeiculo && <figure className="cw-vehicle-photo">
            <img src={fotoVeiculo} alt={formData.veiculo} onError={() => setFotoFalhou(fotoVeiculo)} />
            <figcaption><strong>{formData.veiculo}</strong><span>{formData.placa} · {formData.ano}</span></figcaption>
          </figure>}

          <div>
            
            <div className="form-row">
              <div className="form-group">
                <label>Valor da Venda *</label>
                <input
                  ref={campoRefs.valorVenda}
                  type="text"
                  name="valorVenda"
                  value={formData.valorVenda}
                  onChange={handleChange}
                  inputMode="numeric"
                  className={erros.valorVenda ? 'error' : ''}
                  placeholder="R$ 0,00"
                />
                {erros.valorVenda && <span className="error-message">{erros.valorVenda}</span>}
              </div>

              <div className="form-group">
                <label>Valor de Entrada</label>
                <input
                  type="text"
                  name="entrada"
                  value={formData.entrada}
                  onChange={handleChange}
                  inputMode="numeric"
                  placeholder="R$ 0,00"
                />
              </div>

              <div className="form-group">
                <label>Valor Financiado</label>
                <input
                  type="text"
                  value={formData.financiado}
                  disabled
                  style={{ 
                    background: '#e8f5e9', 
                    cursor: 'not-allowed',
                    fontWeight: '600',
                    color: '#2e7d32'
                  }}
                  placeholder="Calculado automaticamente"
                />
              </div>
            </div>
          </div>

          {/* Observações e Cliente na Loja */}
          <div style={{ marginBottom: '1.5rem' }}>
            <div className="form-group full-width">
              <label>Observações</label>
              <textarea
                name="observacoes"
                value={formData.observacoes}
                onChange={handleChange}
                rows="3"
                placeholder="Informações adicionais sobre a simulação..."
                style={{ width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #ddd' }}
              />
            </div>

            <div className="form-group" style={{ marginTop: '1rem' }}>
              <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '1rem', fontWeight: '500' }}>
                <input
                  type="checkbox"
                  name="clienteNaLoja"
                  checked={formData.clienteNaLoja}
                  onChange={handleChange}
                  style={{ width: '20px', height: '20px', marginRight: '10px', cursor: 'pointer' }}
                />
                <span style={{ color: formData.clienteNaLoja ? '#2e7d32' : '#666' }}>
                   Cliente está na loja (Prioridade)
                </span>
              </label>
            </div>
          </div>
          </>}
          {step === 3 && <>
            <ReviewCard title="Cliente" onEdit={() => setStep(0)} rows={[
              ['Nome', formData.nome], ['CPF', formData.cpf], ['Nascimento', formData.nascimento.split('-').reverse().join('/')], ['Celular', formData.celular], ['CNH', formData.cnh]
            ]} />
            <ReviewCard title="Veículo" onEdit={() => setStep(1)} rows={[
              ['Marca / Modelo', formData.veiculo], ['Placa', formData.placa], ['Ano', formData.ano], ['Combustível', formData.combustivel]
            ]} />
            <ReviewCard title="Valores e atendimento" onEdit={() => setStep(2)} rows={[
              ['Valor de venda', formData.valorVenda], ['Entrada', formData.entrada || 'R$ 0,00'], ['Valor financiado', formData.financiado || 'R$ 0,00'], ['Cliente na loja', formData.clienteNaLoja ? 'Sim' : 'Não'], ['Observações', formData.observacoes]
            ]} />
          </>}
    </CreationWizard>
  );
}

export default NovaSimulacao;
